import React, { useEffect, useState } from "react";
import './Subscription.scss'
import Terms from "../commonComponents/Terms";
import Footer2 from "../commonComponents/Footer2";
import langIcon from "../assets/icons/language_icon.png"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { reactLocalStorage } from "reactjs-localstorage";
import config from "../config";
import { useLanguage } from "../Context/LangContext";
import { logEventHome } from "../Analytics/AnalyticsEvent";
import { screen } from "../Analytics/EventName";
import Sorry from "../commonComponents/Sorry";
import { SendGuiDataEvents } from "../CommonSript";
import logo from "../assets/icons/logo.png"


const Subscription=({homeLogo,banners,loading,setLoading})=>{
    const [msisdn, setMsisdn] = useState('');
    const [subscriptionRate, setSubscriptionRate] = useState('');
    const [lang, setLang] = useState(localStorage.getItem("lang") ? localStorage.getItem("lang") : "ar");
    const history = useHistory();
    const [urlMsisdn,setUrlMsisdn]=useState("");
    const [urlPin,setUrlPin]=useState("");
    const [openSorry,setOpenSorry]=useState(false)
    const {setSourceFile,ip}=useLanguage();  
    const isFormValid =  msisdn.length === 9 && subscriptionRate !== '';
    
    const handleInputChange = (e) => {
        const value = e.target.value;
        // Allow only digits to be entered
        if (/^\d*$/.test(value)) {
            setMsisdn(value);
        }
        localStorage.setItem("tempMsisdn","971"+msisdn);
    };

    useEffect(() => {
        let guiDataEvents = {};
        guiDataEvents["page"] = "subscription";
        guiDataEvents["event"] = "open";
        SendGuiDataEvents(guiDataEvents);
      }, []);

    const goToSorry=()=>{
        let guiDataEvents = {};
        guiDataEvents["page"] = "subscription";
        guiDataEvents["event"] = "exitButton_clicked";
        SendGuiDataEvents(guiDataEvents);
        setOpenSorry(true)
      }

    const toggleLanguage = () => {
        const newLang = lang === "en" ? "ar" : "en";
        setLang(newLang);
        localStorage.setItem("appLang", newLang);
        localStorage.setItem("lang", newLang);
    };

    const checksub = () => {
        let guiDataEvents = {};
        guiDataEvents["page"] = "subscription";
        guiDataEvents["event"] = "checksub_request";
        SendGuiDataEvents(guiDataEvents);
        setLoading(true)
        const url = `${config.get('base')}${config.get('checkSub')}`
        const headers={
            ...config.get('headers'),
            "Language":lang
        }
        fetch(url, {
            method: 'POST',
            body: JSON.stringify({ 
                'msisdn': urlMsisdn,
                "pin":urlPin,
             }),
            headers: headers
        })
            .then(res => {
                if (!res.ok) { throw res }
                return res.json()
            })
            .then((result) => {
                console.log('result message::', result);
                let guiDataResEvents = {};
                guiDataResEvents["page"] = "subscription";
                guiDataResEvents["event"] = "checksub_response";
                guiDataResEvents["status"] = result?.subStatus;
                SendGuiDataEvents(guiDataResEvents);
                reactLocalStorage.set("subStatus", result.subStatus)
                reactLocalStorage.set("pin", urlPin)
                reactLocalStorage.set("status_display", result.status_display)
                reactLocalStorage.set("showUnsub",result.showUnsub)
                reactLocalStorage.set("msisdn", result.msisdn)
                
                reactLocalStorage.set("validity",result.validity)
                reactLocalStorage.set("activePlan",result.subType)
                setLoading(false)
                if(result?.status==="success")
                    {
                        if(result?.subStatus==='active')
                            {
                                localStorage.setItem("wasCheckSubDone",true)
                                history.push("/home")
                            }
                        else{
                            history.push("/");
                            }
                    }
                else 
                {
                    history.push({
                        pathname: "/info",
                        state: { status: "checksubfailed",customMessage:result?.message }
                        })
                    
                }
                logEventHome(
                    {
                        screen: screen.homePage,
                        event: "checksub_api_success"
                    },
                    {
                        others : {
                            status : result.subStatus  ? result.subStatus  : "",
                            msisdn : msisdn  ? msisdn  : "NA"
                        }
                    });
            },
                (error) => {
                    console.log('error:::', error)
                })
    }
 useEffect(()=>
{
    const params = window.location.href;    
    const paramsArray = params.split('&');
    let msisdnValue = '';
    let pinValue = '';
    const msisdnParam = paramsArray.find(param => param.includes('msisdn'));
    if (msisdnParam) {           
        const keyValue = msisdnParam.split('=');       
        msisdnValue = keyValue[1];
        setUrlMsisdn(msisdnValue)
    }
    const pinParam = paramsArray.find(param => param.includes('pin'));
    if (pinParam) {
        const keyValue = pinParam.split('=');
        pinValue = keyValue[1];
        setUrlPin(pinValue)
    }
    if(urlMsisdn && urlPin)
        {
            checksub()
        }

},[urlMsisdn])
    useEffect(() => {
        const storedLang = localStorage.getItem("lang" ) ? localStorage.getItem("lang" ) : "ar" ;
        if (storedLang) {
            setLang(storedLang);
        }
          if (localStorage.getItem("campId") && localStorage.getItem("rcId")) {
            setSubscriptionRate('daily')  
        }
    }, []);
    const subsribe = () => {
        let guiDataEvents = {};
        guiDataEvents["page"] = "subscription";
        guiDataEvents["event"] = "otp_resquest";
        guiDataEvents["packType"] = subscriptionRate;
        SendGuiDataEvents(guiDataEvents);
        setLoading(true)
        const url = `${config.get('base')}${config.get('sendOtp')}`
        const headers={
            ...config.get('headers'),
            Language:lang
        }
        fetch(url, {
            method: 'POST',
            body: JSON.stringify({ 'msisdn': "971" + msisdn ,"packtype":subscriptionRate,
            "ip":ip || localStorage.getItem("ipAddress"),
            "ua":navigator?.userAgent,
            "url":window.location.href
            }),
            headers: headers
        })
            .then(res => {
                if (!res.ok) { throw res }
                return res.json()
            })
            .then((result) => {
                const otpStatus = result?.status
                console.log('result message::', result);
                let guiDataEvents = {};
                guiDataEvents["page"] = "subscription";
                guiDataEvents["event"] = "otp_response";
                guiDataEvents["status"] = otpStatus;
                SendGuiDataEvents(guiDataEvents);
                     
                if(result?.status==="success" && result?.antifraud_status==="success")
                    {
                    localStorage.setItem("selector",result?.cta_selector);
                    localStorage.setItem("tempMsisdn","971"+msisdn);
                    localStorage.setItem("packType",subscriptionRate)
                    setSourceFile(result?.source)
                    setLoading(false);
                    history.push({
                    pathname: "/otp",
                    state: { msisdn: msisdn }
                    })
                  }
                 else  if(result?.status==="failure" && result?.content_link)
                    {
                     window.location.replace(result?.content_link)
                  } 
                else
                {
                    setLoading(false);
                    console.log("something went wrong")
                    history.push({
                        pathname: "/info",
                        state: { status: "sendOtpfailure" }
                    }                    
                    )
                }
            },
                (error) => {
                    console.log('error:::', error)
                })
    }
    const openOtpPage=()=>{
        if(isFormValid)
            {
                subsribe();
            }
    }
    if(openSorry) return < Sorry handleSorry={setOpenSorry}/>;
   
     return(
        <>
        {(loading ) ?<div className="loader-container">
      <div className="lds" ></div>
      </div> :
        <div className="container" style={{whiteSpace:"break-spaces"}}>
            <div className={`stripe ${lang === "ar" ? "rtl" : ""}`}>{lang === "en" ? "Free for 24 hours then AED 2.10/ day or AED 11/ week (VAT inclusion)" : "مجانا لمدة 24 ساعة من 2.10 درهم إماراتي / يومياً  أو 11 درهم إماراتي / أسبوعياً  (شامل ضريبة القيمة المضافة) "} </div>
            <div className="images">
                <img 
                className="logosub"
                src={homeLogo ? homeLogo : logo}
                alt="logo"></img>
                <img 
                className="lang"
                src={langIcon}
                onClick={toggleLanguage}
                alt="language"></img>
            </div>
                 <div className="bannerlp">
                    <img src={banners[0]?.img} className="imglp" alt="banner"></img>
                 </div>

                 <div className="description">
                    {lang === "en" ? "Revolutionizing the World of Gaming" : "إحداث ثورة في عالم الألعاب"}
                 </div>

                <div className={`text ${lang === "ar" ? "rtl" : ""}`}>
                {lang === "en" ? "Please enter Etisalat mobile number to recieve OTP" : "أدخل رقم الهاتف  الخاص بك من اتصالات لتلقي كلمة المرور لمرة واحدة (OTP)."}
                </div>
                <div className="input-group">
                <span className="input-group-addon">+971</span>
                <input type="tel" className="form-control" placeholder={lang === "en" ? "Enter your mobile number" : "أدخل رقم هاتفك المحمول"}
                    value={msisdn} onChange={handleInputChange} />
            </div>
                    {msisdn.length > 0 && msisdn.length !== 9 &&   <p className="alert-text"> {lang === "en" ? "Please enter correct mobile number" :"الرجاء إدخال رقم الجوال الصحيح"}</p> }

            <div className={`radio-buttons ${lang === "ar" ? "rtl" : ""}`}>
                <label>
                    <input type="radio" value="daily" checked={subscriptionRate === 'daily'}
                        onChange={() => {
                            setSubscriptionRate('daily')}} 
                            />
                     {lang === "en" ?"AED 2.10/day" : "2.10 درهم إماراتي في اليوم"}
                </label>
                <label>
                    <input type="radio" value="weekly" checked={subscriptionRate === 'weekly'}
                        onChange={() => { 
                            setSubscriptionRate('weekly')}} />
                    {lang === "en" ? "AED 11/week" : "11 درهماً/أسبوعياً"}
                </label>
            </div>

             <div className="buttons">
            <button className="btn btn-primary subscribe text-white" disabled={!isFormValid} onClick={openOtpPage}>{lang === "en" ? "Subscribe" : "اشترك"}</button>
            <div className={`text white word-break ${lang === "ar" ? "rtl" : ""}`}>{lang === "en" ? "Free for 24 hours then" : "مجانا لمدة 24 ساعة من"} <span className="spantext">{lang === "en" ?"AED 2.10/ day" : "2.10 درهم إماراتي / يومياً "}</span> {lang === "en" ? "or" : "أو"} <span className="spantext">{lang === "en" ?"AED 11/ week " : "11 درهم إماراتي / أسبوعياً "}</span>{lang === "en" ? "(VAT inclusion)" : " (شامل ضريبة القيمة المضافة) "}</div>
            <button className="btn btn-primary white"  onClick={goToSorry}> {lang === "en" ? "Exit" : "خروج"}</button>
            </div>

            <div className={`textsmall white word-break ${lang === "ar" ? "rtl" : ""}`}>{lang === "en" 
  ? 'After clicking "Subscribe" you will receive a PIN message to confirm your subscription' 
  : 'بعد النقر على "اشتراك"، ستتلقى رسالة PIN لتأكيد اشتراكك'}</div>

            <Terms/>
            <Footer2 homeLogo={homeLogo}/>
        </div>}

        </>
     )
}

export default Subscription